<template>
    <v-app id="app">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </v-app>
</template>

<script>
    export default {
        mounted() {
            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
                this.$vuetify.theme.dark = e.matches;
            });
        }
    }
</script>
